import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-display',
  templateUrl: './document-display.component.html',
  styleUrls: ['./document-display.component.scss']
})
export class DocumentDisplayComponent implements OnInit{
  @Input() document;
  constructor() { }

  ngOnInit(): void {
  }

  getType(pathName: string) {
    if(pathName){
      let extension = pathName.split('.')
      let type = extension[extension.length - 1]
      if (type.toLowerCase() == 'png' || type.toLowerCase() == 'jpeg' || type.toLowerCase() == 'jpg' ) {
        return 'img';
      }else{
        return 'file'
      }

    }
    return null;
  }

}
